<template>
  <div id="app">
    <transition name="fade">
      <div id="toast" v-if="toast.show" :class="`toast toast-${toast.type}`">
        {{ toast.message }}
      </div>
    </transition>
    <nav>
      <span v-for="(route, index) in routes" :key="route.path">
      <router-link :to="route.path">{{ route.name }}</router-link>
      <span v-if="index < routes.length - 1"> | </span>
    </span>
    </nav>
    <div id="filter-selectors">
      <select id="week-selector" v-model="selectedWeek" @change="onFilterChange">
        <option v-for="week in weeks" :key="week" :value="week">
         KW {{ week }}
        </option>
      </select>
      <select id="year-selector" v-model="selectedYear" @change="onFilterChange">
        <option v-for="year in years" :key="year" :value="year">
          {{ year }}
        </option>
      </select>
      <div class="search-wrapper">
        <input
            id="search-field"
            name="search"
            type="text"
            v-model="searchInput"
            @keyup.enter="updateSearchQuery"
            placeholder="Suchen..."
        />
        <span v-if="searchInput" class="clear-icon" @click="clearSearch">×</span>
      </div>
      <button @click="updateSearchQuery">Suchen</button>
      <label style="margin-left: 15px; font-size: 0.9rem;">
        <input type="checkbox" v-model="hideNonMatchingRows" />
        Nur Treffer anzeigen
      </label>
    </div>
    <router-view :key="$route.fullPath" :selected-week="selectedWeek" :selected-year="selectedYear" :search-query="searchQuery" :hide-non-matching-rows="hideNonMatchingRows"/>
  </div>
</template>

<script>

import router from './main'
export default {
  name: 'App',
  data() {
    const currentDate = new Date();
    // Set the date to one week (7 days) before the current date
    currentDate.setDate(currentDate.getDate() - 7);
    const currentWeek = this.getWeekNumber(currentDate);
    return {
      routes: [],
      toast: { show: false, message: "", type: "" },
      selectedWeek: localStorage.getItem('selectedWeek') ? parseInt(localStorage.getItem('selectedWeek')) : currentWeek,
      selectedYear: localStorage.getItem('selectedYear') ? parseInt(localStorage.getItem('selectedYear')) : currentDate.getFullYear(),
      weeks: Array.from({ length: 52 }, (_, i) => i + 1),
      years: Array.from({ length: 10 }, (_, i) => currentDate.getFullYear() - i),
      searchInput: '',
      searchQuery: '',
      hideNonMatchingRows: localStorage.getItem('hideNonMatchingRows') !== 'false'
    };
  },
  created() {
    this.routes = router.getRoutes().filter(route => route.path !== '/');
  },
  watch: {
    $route() {
      this.clearSearch();
    },
    hideNonMatchingRows() {
      this.onFilterChange();
    }
  },
  methods: {
    showToast(type, message) {
      this.toast.type = type;
      this.toast.message = message;
      this.toast.show = true;
      setTimeout(() => {
        this.toast.show = false;
      }, 10000); // hide the toast after 3 seconds
    },
    onFilterChange() {
      localStorage.setItem('selectedWeek', this.selectedWeek);
      localStorage.setItem('selectedYear', this.selectedYear);
      localStorage.setItem('hideNonMatchingRows', this.hideNonMatchingRows);
    },
    updateSearchQuery() {
      this.searchQuery = this.searchInput;
    },
    getWeekNumber(date) {
      const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
      const pastDaysOfYear = (date - firstDayOfYear) / 86400000;
      return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
    },
    clearSearch() {
      this.searchInput = '';
      this.searchQuery = '';
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
a {
  color: #2c3e50;
}
.toast {
  position: fixed;
  padding: 10px;
  color: white;
  border-radius: 5px;
  z-index: 10000;
}
.toast-success {
  background-color: #4caf50;
}
.toast-error {
  background-color: #f44336;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

.fade-enter-active {
  transition: opacity 0.2s;
}

.fade-leave-active {
  transition: opacity 0.5s;
}
nav {
  margin-bottom: 20px;
  font-size: 0.8rem;
  a {
    white-space: nowrap;
  }
}

.router-link-active {
  font-weight: bold;
}

#filter-selectors {
  margin: 10px 0;
}

#filter-selectors label {
  margin-right: 5px;
}

#filter-selectors select {
  margin-right: 20px;
}

#search-field {
  margin-right: 20px;
  padding-right: 24px; /* space for the icon */
}

.search-wrapper {
  position: relative;
  display: inline-block;
}

.clear-icon {
  position: absolute;
  right: 24px;
  top: 55%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 24px;
  color: #999;
  user-select: none;
}

.clear-icon:hover {
  color: #333;
}
</style>